<script setup lang="ts">
import ThLink from '@/components/ui/buttons/ThLink.vue'
import { useRoutes } from '@/router/routes.ts'
import { useI18n } from 'vue-i18n'

const routes = useRoutes()
const { t } = useI18n()
</script>

<template>
    <div class="rtg-banner">
        <ThLink
            :to="routes.readyToGoRings()"
            class="catalogue-switch"
        >
            {{ t('catalogue.engagement_ring.rtg_banner.title') }}
            <span class="highlighted">{{
                t('catalogue.engagement_ring.rtg_banner.link')
            }}</span>
        </ThLink>
    </div>
</template>

<style scoped lang="scss">
.rtg-banner {
    display: flex;
    justify-content: center;

    .catalogue-switch {
        padding: 10px 20px;
        background-color: $stone-2;
        align-self: center;
        border-radius: 60px;
        font-size: 0.75rem;
        line-height: 1.25rem;

        @include min-width(640) {
            padding: 10px 30px;
            font-size: 0.875rem;
        }

        .highlighted {
            font-family: $effra-font-stack;
            font-size: 0.675rem;
            font-weight: 400;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            color: $blue;

            @include min-width(640) {
                font-size: 0.75rem;
            }
        }
    }
}
</style>
